import { useState, useEffect } from "react";
import { fetchSourceDetail } from "../api";
import type { SourceDetailResponse } from "../types";

interface UseSourceDetailResult {
  data: SourceDetailResponse | null;
  loading: boolean;
  error: string | null;
}

export function useSourceDetail(sourceType: string, sourceId: string): UseSourceDetailResult {
  const [data, setData] = useState<SourceDetailResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchSourceDetail(sourceType, sourceId)
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err?.message || "Failed to load source details");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [sourceType, sourceId]);

  return { data, loading, error };
}
